/**
 * Protege rutas de store que requieren cliente logueado (solo su lead).
 * Redirige a /store/login si no hay sesión de cliente, preservando la URL para volver tras login.
 */

import { Navigate, useLocation } from 'react-router-dom';
import { useClientLead } from '@/hooks/use-store';

interface RequireStoreAuthProps {
  children: React.ReactNode;
}

export function RequireStoreAuth({ children }: RequireStoreAuthProps) {
  const location = useLocation();
  const { data: clientLead, isLoading, isFetching } = useClientLead();

  if (isLoading || (isFetching && !clientLead)) {
    return (
      <div className="flex items-center justify-center min-h-[200px]">
        <p className="text-zinc-500">Cargando...</p>
      </div>
    );
  }

  if (!clientLead) {
    return <Navigate to="/store/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
